import Contact9 from './Contact9'
export default Contact9
